var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('van-nav-bar',{attrs:{"title":"设置","left-arrow":"","fixed":"","placeholder":"","safe-area-inset-top":""},on:{"click-left":_vm.goBack}}),_c('div',{staticClass:"content"},[_c('button',{staticClass:"logout-btn",attrs:{"type":"button"},on:{"click":_vm.handleLogout}},[_vm._v(" 退出登录 ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }